import {
  DataTable,
  DataTableProps,
  DataTableSortStatus,
} from 'mantine-datatable';

const EMPTY_TABLE_HEIGHT = 200;
const BORDER_COLOR = 'var(--mantine-color-gray-2)';
const TEXT_COLOR = '#4F4F4F';

type TouringDataTablePropsType<T> = Omit<
  DataTableProps<T>,
  'sortStatus' | 'onSortStatusChange'
> & {
  sortStatus?: DataTableSortStatus;
  onSortStatusChange?: (newSortStatus: DataTableSortStatus) => void;
};

export const TouringDataTable = <T,>({
  ...props
}: TouringDataTablePropsType<T>): React.ReactElement => {
  return (
    // @ts-expect-error - mantine-datatable types are trash
    <DataTable<T>
      withTableBorder
      withColumnBorders
      withRowBorders
      highlightOnHover
      minHeight={
        (props.records?.length ?? 0 > 0) ? undefined : EMPTY_TABLE_HEIGHT
      }
      c={TEXT_COLOR}
      borderColor={BORDER_COLOR}
      {...props}
    />
  );
};
